<form [formGroup]="personalDetailForm" autocomplete="off" role="form">


        

        <div class="form-group form-field">

                <label id="lbl-dob" for="dateOfBirth" class="col-sm-11 col-md-11 form-label">
                        {{contentData['personalDetail']['dateOfBirth']}}

                </label>

                <div class="col-sm-11 col-md-11">
                        <input class="form-control" id="dateOfBirth" name="dateOfBirth" formControlName="dateOfBirth"
                                type="DATE" max="9999-12-31">
                        <div id="select-error" class="form-validation-error"
                                *ngIf="personalDetailForm.get('dateOfBirth').touched && personalDetailForm.get('dateOfBirth').errors?true:false">
                                <i class="icon icon-error" aria-hidden="true"></i>
                                <p id="text-dob-error">{{contentData['personalDetail']['dateOfBirthError']}}</p>
                        </div>
                </div>
                <div class="col-md-1">
                        <img id="img-dob-open" *ngIf="!infoModalIsDOBVisible" (click)="toggleInfoDOBOpen()" alt="infomation"
                                src="./assets/images/Info Copy.svg">
                        <img id="img-dob-close" *ngIf="infoModalIsDOBVisible" (click)="toggleInfoDOBClose()" alt="infomation"
                                src="./assets/images/Info Close.svg">
                        <div *ngIf="infoModalIsDOBVisible" class="info-modal clear-both">
                                <div class="need-help-text">
                                        <div class="legal" id="text-dob-information">
                                                {{contentData['personalDetail']['dobInformation']}}
                                        </div>
                                </div>
                        </div>
                </div>


        </div>
        
           
      
        <div class="form-group form-field">
                <label class="col-sm-11 col-md-11 form-label" id="lbl-uk-address"
                        style="margin-top: 32px">{{contentData['personalDetail']['ukaddressIndicator']}}</label>
                <div class="col-sm-11 col-md-11  ">
                        <app-radio-button id="ukaddressIndicator" name="ukaddressIndicator"
                                (toggleContainer)="toggleContainer($event)" [configValue]="radioButtonIsUKAddress">
                        </app-radio-button>
                </div>
                <div class="col-md-1">
                        <img id="img-post-code-open" *ngIf="!infoModalIsUkPostcodeVisible" (click)="toggleInfoPostCodeOpen()" alt="infomation"
                                src="./assets/images/Info Copy.svg">
                        <img id="img-post-code-close" *ngIf="infoModalIsUkPostcodeVisible" (click)="toggleInfoPostCodeClose()" alt="infomation"
                                src="./assets/images/Info Close.svg">
                        <div *ngIf="infoModalIsUkPostcodeVisible" class="info-modal clear-both">
                                <div class="need-help-text">
                                        <div class="legal" id="text-post-code">
                                                {{contentData['personalDetail']['postCodeInformation']}}
                                        </div>
                                </div>
                        </div>
                </div>

        </div>
        <div  *ngIf="personalDetailForm.get('ukaddressIndicator').value==='Y'?true:false"
                class="col-sm-11 col-md-11 form-group " style="margin-top: 32px">

                

        </div>






</form>